<script setup lang="ts">
import { ref, onMounted } from "vue";
import EpdServiceClient from "@/api/EpdServiceClient";

import InspectMaterial from "@/components/Views/MaterialMapping/Library/Modal/InspectConstruction/InspectMaterial.vue";
import { Loader2 } from "@lucide/vue";

const props = withDefaults(
  defineProps<{
    data?: any;
    parentName?: any;
    materialId?: string | null;
    isConstruction?: boolean;
  }>(),
  {
    data: null,
    parentName: null,
    materialId: null,
    isConstruction: false,
  }
);

const isLoading = ref<boolean>(false);
const selectedConstruction = ref<any | null>(null);

onMounted(async () => {
  if (props.data) {
    // Data was passed directly, use it
    selectedConstruction.value = props.data;
  } else if (props.materialId && props.isConstruction) {
    // Need to fetch construction data
    isLoading.value = true;
    try {
      const response = await EpdServiceClient.get(`api/construction/${props.materialId}`);
      selectedConstruction.value = response.data;
    } catch (error) {
      console.error("Failed to fetch construction data:", error);
    } finally {
      isLoading.value = false;
    }
  }
});
</script>

<template>
  <div
    v-if="isLoading"
    class="flex h-64 items-center justify-center">
    <div class="flex flex-col items-center gap-3">
      <Loader2
        class="icon-xl text-app-blue-600 animate-spin"
        :stroke-width="1.5" />
      <span class="text-sm text-slate-500">Loading material data...</span>
    </div>
  </div>
  <InspectMaterial
    v-else-if="selectedConstruction"
    :parent-name="parentName"
    :material="selectedConstruction"
    @clear-select="selectedConstruction = null" />
  <div
    v-else
    class="flex h-64 items-center justify-center">
    <span class="text-sm text-slate-500">No material data available</span>
  </div>
</template>
